export default {
  methods: {
    load_images (url) {
      return require(`../assets/${url}`);
    }
  }
}